import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserRoles } from '../models/user-roles.enum';
import { UserMatchClient } from '../clients/user-match.client';
import { ProfileInfo } from '../models/profile-info.model';
import { CustomValidator } from '../validators';

@Injectable({
  providedIn: 'root',
})
export class TeamMemberService {
  private userMatchClient = inject(UserMatchClient);

  searchAgents(searchTerm?: string, onlyDelegatedUsers?: boolean, excludeTeamMembers?: boolean, roles?: string, filterLicenseNumber?: boolean, filterRealEstateRole?:string, agentIds?: string[]): Observable<ProfileInfo[]> {
    searchTerm = CustomValidator.stringValueOf(searchTerm).toLowerCase();
    if (searchTerm === '') {
      return of([]);
    }
    const searchAgents = {
      search: searchTerm, excludeTeamMembers, roles, filterLicenseNumber, filterRealEstateRole, agentIds,
    };
    return this.userMatchClient.get(searchAgents);
  }

  searchAgentsById(agentIds: string[], searchBy?: string) {
    if (searchBy === UserRoles.AGENT_PROFILE) {
      return this.userMatchClient.get({ profileIds: agentIds });
    }
    // TODO: This needs to be hooked up to the endpoint or the information needs to be returned with the
    // existing queries (i.e. - TeamProfiles and marketing-order)
    return this.userMatchClient.get({ userIds: agentIds });
  }
}
